import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder,Validators, FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService, SharedserviceService } from 'src/app/services';
import { Select2OptionData } from 'ng-select2';
import { Options } from 'select2';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { DateAdapter } from '@angular/material';

declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss'],
  providers:[DatePipe,NgxUiLoaderService]
})
export class OffersComponent implements OnInit {
  public options: Options;   Arrivalcity_DATA: arrivalcity_lists[] = [];   disableDate: boolean;
  return_d_date: any;   selectFlightType: any;   return_date: any;   arrivaldate_input: boolean = false;
  rreturn_d_date: any;   disableInput: boolean = true; return_date_input: boolean = false;
  travDetl:any;   flighttype: any = 'oneway';   d_date: any;
  searchdate: any = '';   return_min_date:any;  return_max_date:any;
  aval_seat: any;   myFilter: any;   myFilter1: any;
  adult:number =1;   departure_date: boolean = false;  child:number =0;
  booking_token: any;  departurePartnerList: any;  arrivalPartnerList: any;
  travellerShow:boolean=false;   filterlist: any = [];  infant:number =0;
  traveller_input: boolean = false;  readMore:boolean=false;
  b_city: any = [];  d_city: any = [];  a_city: any = [];
  departure_Date_start: any;  departure_Date_end: any;
  departure_city_data: Array<Select2OptionData>;  arrival_city_data: Array<Select2OptionData>;
  minDate: any;  maxDate: any;   date:any;   search_details: any;
  todayDate:any=new Date();
  // showSelf:any= false;
  // showSelfBlock :any= false;
  // flightdetails:any=[];
  // flightBlockedDetails:any=[];
  data:any;keys:any;public page: number = 1;start = 0;msg:any;  travellerDetail: any;  ccData:any;  TotalCount:any;
  totalseatCount:any;  totalpage:any;
  total: any=Number(JSON.parse(sessionStorage.getItem("search_form_Data")).infant)+Number(JSON.parse(sessionStorage.getItem("search_form_Data")).children)+Number(JSON.parse(sessionStorage.getItem("search_form_Data")).adult);
  element:any;  travellers: FormGroup;  searchForm: FormGroup;
  offerList:any;  DataReturn:any;  combine:any=[];
  ownerData: any;  flights_Dtl:any=[];  flights_Block_Dtl:any=[];  flights_showself:any=[];
  flights_showself_Block:any=[];
  baseImageUrl:any;  flightdetails: any;  submitted: boolean;  Airlines: any = [];
  Destinations: any = [];  imagesrc: string;  flightdetails_old: any;  formdata: any;
  departure_city_ids: any;  arrival_city_ids: any;
  newCal: any;  newCal2: any;  newCal3: any;
  @ViewChild('arrivalSelect', { static: true }) arrivalSelect: MatSelect;
  @ViewChild('departureSelect', { static: true }) departureSelect: MatSelect;
  public filtered_departurecity: ReplaySubject<departurecity_lists[]> = new ReplaySubject<departurecity_lists[]>(1);
  public filtered_arrivalcity: ReplaySubject<arrivalcity_lists[]> = new ReplaySubject<arrivalcity_lists[]>(1);
  options1: { templateResult: (state: Select2OptionData) => JQuery | string; templateSelection: (state: Select2OptionData) => JQuery | string; };
  Departurecity_DATA: departurecity_lists[] = [];
  protected _onDestroy = new Subject<void>();
  protected _onDestroy1 = new Subject<void>();
  public departureFilterCtrl: FormControl = new FormControl();
  public arrivalFilterCtrl: FormControl = new FormControl();
  previous_day: any;
  to_day: any;
  next_day: any;
  isSelectedDate: any;
  isSelectedDateArray: any;
  user: any;
  constructor(private dateAdapter: DateAdapter<Date>,private activatedRoute: ActivatedRoute,public sharedService: SharedserviceService,
    public commonService:CommonService,private ngxLoader: NgxUiLoaderService,private toastr: ToastrManager,private fb: FormBuilder,public router: Router,private datePipe: DatePipe
  ) {
    this.commonService.GetDateArray().subscribe((data:any)=>{
      console.log("flight_date>>>>>",data);
      if(data.length>0){
        this.d_date=data;
        this.isSelectedDateArray=data;
      }
    })
    this.searchForm = this.fb.group({
      departure_city_id: ['', [Validators.required]],  
      departure_city_code:['',[Validators.required]],  
      departure_airport_id: ['', [Validators.required]],
      arrival_city_id: ['', [Validators.required]],  
      arrival_city_code:['',[Validators.required]],  
      arrival_airport_id: ['', [Validators.required]],
      trip_type: ['0', [Validators.required]],  
      departure_date: ['', [Validators.required]],  
      return_date: [''],
      adult: 1,  child: 0,  travellers: '1',  infant: 0
    });
    this.travellers = this.fb.group({   adult: ['1'],    child: ['0'],   infant: ['0'] });
    this.dateAdapter.setLocale('en-GB');
    this.ownerData= JSON.parse(sessionStorage.getItem("ownerData"));
    this.travDetl = JSON.parse(sessionStorage.getItem("travlerDetail"));
    this.flightdetails = JSON.parse(sessionStorage.getItem("flightDetails"));
    this.booking_token = JSON.parse(sessionStorage.getItem("Booking_token"));
    this.baseImageUrl = JSON.parse(sessionStorage.getItem("imagepath"));
    this.formdata = JSON.parse(sessionStorage.getItem("search_form_Data"));
    // console.log("check images base url::::::::::",this.travDetl);
    this.flights_Dtl = this.flightdetails;
    this.departure_city_list(); 
    this.user = JSON.parse(localStorage.getItem("userAgency_dealfare"));
   }

  ngOnInit() {
    this.searchsubmit(); 
    console.log("this.formdata>>>>>>",this.formdata)
    this.searchForm.controls["departure_city_id"].setValue(this.formdata.departure_city_id);
    this.searchForm.controls["arrival_city_id"].setValue(this.formdata.arrival_city_id);
    this.searchForm.controls["travellers"].setValue(this.formdata.travellers);
    this.commonService.GetAvaliableDate().subscribe((data)=>{
      console.log("flight_date>>>>>",data);
      if(data != ''){
        this.to_day=JSON.parse(sessionStorage.getItem("availabletodate"));
        this.currentDateStep = this.d_date.findIndex(e => e.flight_date == this.to_day);
        console.log("currentDateStep>>>>",this.currentDateStep)
      }
    })
   
    // if(sessionStorage.getItem("availabletodate") !='' || sessionStorage.getItem("availabletodate") !=undefined || sessionStorage.getItem("availabletodate") !=null){
    //   this.to_day=JSON.parse(sessionStorage.getItem("availabletodate"));
    //   var findindex = this.d_date.findIndex(e => e.flight_date == this.to_day);
    //   if (this.d_date[findindex - 1] == undefined) {  this.previous_day = '';  } else {  this.previous_day = this.d_date[findindex - 1]  }
    //   if (this.d_date[findindex + 1] == undefined) {  this.next_day = ''; } else {  this.next_day = this.d_date[findindex + 1]  }
    // }
  }


  renderdata() {
    this.search_details = this.searchForm.value;
    setTimeout(() => {
      if(this.flightdetails != '') {
        this.flightdetails.forEach(element => {

          var obj = element;

          if (element.inventory_user_Type == 'Patner') {
            element.total_payable_price_with_travellers = element.total_payable_price * this.search_details.travellers
            // console.log("element=========>>>",element.total_payable_price_with_travellers);
          }
          if (element.inventory_user_Type == 'fareboutique' && element.add_margin == 1) {
            // console.log('sunil===========',obj);
            this.newCal = element.vendorAmountLimit < element.total_payable_price;
            this.newCal2 = element.vendorAmountLimit > element.per_ticket_avg_price + element.margin - element.discount;
            this.newCal3 = ~~(element.vendorAmountLimit / (element.per_ticket_avg_price + element.margin - element.discount));
            //  element.total_payable_price=element.total_payable_price + ((element.margin - element.discount)*formData.travellers)  
            element.total_payable_price = element.total_payable_price + ((element.margin - element.discount) * this.search_details.travellers)
            Object.assign(obj, { newCal: this.newCal, newCal2: this.newCal2, newCal3: this.newCal3 })
          }
        });
      }
    }, 100);
    //console.log("searchde")
    setTimeout(() => {
      if (this.search_details.trip_type == '1') {  this.flighttype == 'return'} 
      else {
        this.flighttype == 'oneway';  this.disableInput = true;  this.return_date_input = false;
      }
    }, 1000);  
  }

  open_popup() {
    $('#totalpassengers').modal('show');
  }
  setsearchdate(d) {
    this.searchForm.patchValue({
      departure_date: this.datePipe.transform(d, "yyyy-MM-dd")
    });
    // this.searchForm.value.departure_date = this.datePipe.transform(d, "yyyy-MM-dd");
    console.log("seaer", this.datePipe.transform(d, "yyyy-MM-dd"))
    // this.searchdate = this.datePipe.transform(d, "yyyy-MM-dd")
    this.searchsubmit();
  }


  searchsubmit() {
    const self = this; this.submitted = true;
        this.ngxLoader.start();
        if (this.travDetl == null) {
          var data = { 
            adult: 1, 
            child: 0, 
            infant: 0, 
            total: 1, }
          this.travDetl = data; 
        }
        var datarequest = {
          dep_city_code: this.formdata.departure_city_code, 
          arr_city_code: this.formdata.arrival_city_code,
          departure_city_id: Number(this.formdata.departure_city_id),
          arrival_city_id: Number(this.formdata.arrival_city_id),
          departure_airport_id: this.formdata.departure_airport_id,
          arrival_airport_id: this.formdata.arrival_airport_id,
          departure_date: this.searchdate != '' ? this.searchdate : this.formdata.departure_date,
          return_date: this.formdata.return_date, 
          adult: Number(this.travDetl.adult), 
          children: Number(this.travDetl.child), 
          infant: Number(this.travDetl.infant),
          trip_type:Number(this.formdata.trip_type)
        }
        

        this.sharedService.post('v1/common_new/search', datarequest).subscribe((res: any) => {
          if (res.replyCode == "success") {
            this.flightdetails_old = res.data;
            
            var partnerrequest = { 
              depcode: Number(this.formdata.departure_city_id), 
              arrcode: Number(this.formdata.arrival_city_id) 
            }
            if (res.data.length == 1) { 
              (res.data[0]).partnervalue = 'patner'; 
            } else { 
              (res.data).forEach(element => { 
                element.partnervalue = 'patner' 
              }); 
            }
            sessionStorage.setItem("offerDetail", JSON.stringify(partnerrequest));
            sessionStorage.setItem("Booking_token", JSON.stringify(res.booking_token));
             
            this.flightdetails = this.flightdetails_old;
            (res.data).forEach(element => {
              this.Airlines.push({ name: element.airline_name, is_selected: false })
              this.Destinations.push({ name: element.arrival_city_name, is_selected: false })
            });
            console.log("check data value===========>>>>11111",this.flightdetails);
            sessionStorage.setItem("flightDetails", JSON.stringify(this.flightdetails_old));
            this.submitted = false; 
            this.imagesrc = res.imgBasePath; 
            // this.searchresult = true; 
            this.ngxLoader.stop();
            // this.router.navigateByUrl("/offers");            
          } else {
            this.submitted = false; 
            this.flightdetails = ''; 
            this.imagesrc = '';
            sessionStorage.removeItem("flights"); 
            sessionStorage.removeItem("imagepath");
            self.toastr.errorToastr("Result Not Found", "Error")
          }
          this.ngxLoader.stop();
        }, err => {
          this.ngxLoader.stop(); 
          this.submitted = false; 
          this.flightdetails = '';
          this.imagesrc = ''; 
          this.toastr.errorToastr(err.error.replyMsg, "Error");
        });
  }

  onPrevious() {
    if (this.currentDateStep > 0){
      this.currentDateStep--;
    }
    this.isSelectedDate=this.isSelectedDateArray[this.currentDateStep].flight_date;
    this.searchsubmitoffer();
    console.log("currentDateStep>>>Previous",this.currentDateStep);
  }
  onNext() {
    if (this.currentDateStep < this.isSelectedDateArray.length - 1){
      this.currentDateStep++;
    }
    this.isSelectedDate=this.isSelectedDateArray[this.currentDateStep].flight_date;
    console.log("currentDateStep>>>onNext",this.currentDateStep);
    console.log("isSelectedDate>>>onNext",this.isSelectedDate);
    this.searchsubmitoffer();
  }
  currentDateStep: any = 0;
  
  searchsubmitoffer() {
    const self = this; this.submitted = true;
    let formdata = this.searchForm.value;
    // console.log("=======:::::::check formData value:::::::::::=======>>>",formdata);
      if (formdata.departure_city_code != "" && formdata.arrival_city_code != "") {
        this.ngxLoader.start();
        if (this.travDetl == null) {
          var data = { 
            adult: 1, 
            child: 0, 
            infant: 0, 
            total: 1, }
          this.travDetl = data; sessionStorage.setItem("travlerDetail", JSON.stringify(data));
        }
        var datarequest = {
          dep_city_code: formdata.departure_city_code, 
          arr_city_code: formdata.arrival_city_code,
          departure_city_id: Number(formdata.departure_city_id),
          arrival_city_id: Number(formdata.arrival_city_id),
          departure_airport_id: formdata.departure_airport_id,
          arrival_airport_id: formdata.arrival_airport_id,
          departure_date: this.isSelectedDate,
          return_date: formdata.return_date, 
          adult: Number(JSON.parse(sessionStorage.getItem("search_form_Data")).adult), 
          children: Number(JSON.parse(sessionStorage.getItem("search_form_Data")).child), 
          infant: Number(JSON.parse(sessionStorage.getItem("search_form_Data")).infant),
          trip_type:Number(formdata.trip_type)
        }
        // this.to_day = this.searchForm.value.departure_date; var findindex = this.d_date.findIndex(e => e.flight_date == this.to_day);
        // if (this.d_date[findindex - 1] == undefined) { this.previous_day = ''; }
        // else { this.previous_day = this.d_date[findindex - 1] }
        // if (this.d_date[findindex + 1] == undefined) { this.next_day = ''; }
        // else { this.next_day = this.d_date[findindex + 1] }
        // console.log("checkdatarequest=============>>>>>>", datarequest);
        
        this.sharedService.post('v1/common_new/search', datarequest).subscribe((res: any) => {
          if (res.replyCode == "success") {
            this.flightdetails_old = res.data;
            var partnerrequest = {   
              depcode: Number(this.formdata.departure_city_code),   
              arrcode: Number(this.formdata.arrival_city_code) 
            }
            if (res.data.length == 1) {
                 (res.data[0]).partnervalue = 'patner'; 
            }else {
                 (res.data).forEach(element => {     element.partnervalue = 'patner'   }); 
              }
            sessionStorage.setItem("offerDetail", JSON.stringify(partnerrequest));
            sessionStorage.setItem("Booking_token", JSON.stringify(res.booking_token));
            this.flightdetails = this.flightdetails_old;
            (res.data).forEach(element => {
              this.Airlines.push({ name: element.airline_name, is_selected: false })
              this.Destinations.push({ name: element.arrival_city_name, is_selected: false })
            });
            sessionStorage.setItem("flightDetails", JSON.stringify(res.data));             
            this.submitted = false;   this.imagesrc = res.imgBasePath; 
            this.renderdata();  this.ngxLoader.stop();  //this.router.navigateByUrl("/offers");            
          } else {
            this.submitted = false;   this.flightdetails = '';   this.imagesrc = '';
            sessionStorage.removeItem("flights"); 
            sessionStorage.removeItem("imagepath");
            self.toastr.errorToastr("Result Not Found", "Error")
          }
          this.ngxLoader.stop();
        }, err => {
          this.ngxLoader.stop(); 
          this.submitted = false; 
          this.flightdetails = '';
          this.imagesrc = ''; 
          this.toastr.errorToastr(err.error.replyMsg, "Error");
        });
      }
      else { this.ngxLoader.stop(); this.toastr.errorToastr('Fill The Form Correctly.'); }
    
  }

  timeConvert(n) {
    var num = n;
    var hours = (num / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + " hr  " + rminutes + " min";
  }

  bookflight(flight) {
    console.log("flight ::::::::::::>>>>", flight)
    const self = this;
    var formvalue = this.searchForm.value
    this.aval_seat = flight.pricing.total_available_seats
    console.log("this.aval_seat", this.aval_seat, formvalue)
    var totalseat = Number(formvalue.adult) + Number(formvalue.child) + Number(formvalue.infant)
    console.log("totalseat", totalseat)
    if (this.aval_seat >= totalseat) {
      var senddata = {
        flight_id: flight.flight_id,
        trip_type: formvalue.trip_type,
        departure_date: formvalue.departure_date,
        return_date: formvalue.return_date,
        adult: this.adult,
        children: this.child,
        infant: this.infant,
        inventory_user_Type: "self",
        booking_token: JSON.parse(sessionStorage.getItem("booking_token_id")),
        inv_user: flight.inventory_user_Type
      }
      
      sessionStorage.setItem("searchedflights_detail", JSON.stringify(flight));
      sessionStorage.setItem("partnerSearch", JSON.stringify(true));
      // sessionStorage.setItem("imagepath", JSON.stringify(self.srcimagepath));
      self.router.navigateByUrl("/detail");

      // if (flight.partnervalue == 'patner') {
      //   console.log("hello partner")
      //   sessionStorage.setItem("searchedflights_detail", JSON.stringify(flight));
      //   sessionStorage.setItem("partnerSearch", JSON.stringify(true));
      //   // sessionStorage.setItem("imagepath", JSON.stringify(self.srcimagepath));
      //   self.router.navigateByUrl("/detail");
      // } else if (flight.partnervalue == 'normal') {
      //   console.log("hello partner")
      //   sessionStorage.setItem("partnerSearch", JSON.stringify(false));
        this.commonService.searchedflightdetail(senddata);
      // }
    }
    else {
      $('#confirmbooking').modal('show');
    }
  }

  durationdiff(list,type){
    // console.log("check type list====656====",list, "type check====2====", type);
    
    var dep_time = list.departure_time;  var arr_time = list.arrival_time;
    var dep_date = list.departure_date;     var start_date:any;  var end_date:any;
    var dep_hr=parseInt(dep_time.split(':')[0]);  var arr_hr=parseInt(arr_time.split(':')[0]);
    if (type == 'oneway'){
      // console.log("oneway difference",list.duration,typeof(list.duration))
      if(list.duration == "0"){
        // console.log("duration zero")
        if (arr_hr < dep_hr) {
          var nwdate;
          if (!dep_date) {  nwdate = new Date();  } 
          else {  nwdate = new Date(dep_date);  }
          var newdate = nwdate.setDate(nwdate.getDate() + 1);
          this.return_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
        } 
        else {  this.return_d_date = dep_date;  }
        start_date=dep_date+" "+dep_time;  end_date=this.return_d_date+" "+arr_time;
        return this.getDataDiff(new Date(start_date.toString()), new Date(end_date.toString()));
      }else{
        if(list.next_day == 1){
          // console.log("duration not zero and nextday 1")
          if (!dep_date) {  nwdate = new Date();  } 
          else {  nwdate = new Date(dep_date);  }
          var newdate = nwdate.setDate(nwdate.getDate() + 1);
          this.return_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
        }else{
          // console.log("duration not zero and nextday 0")
          this.return_d_date = list.departure_date;
          // start_date=dep_date+" "+dep_time;  end_date=this.return_d_date+" "+arr_time;
          // return this.getDataDiff(new Date(start_date.toString()), new Date(end_date.toString()));
          return parseInt((list.duration).split(':')[0])+' hr : '+parseInt((list.duration).split(':')[1])+' mins';
        }
        return parseInt((list.duration).split(':')[0])+' hr : '+parseInt((list.duration).split(':')[1])+' mins';
      }
    }else{
        if(list.return_flight_data.duration == "0"){
          if (arr_hr < dep_hr) {
            var nwdate;
            if (!dep_date) {  nwdate = new Date();  } 
            else {  nwdate = new Date(dep_date);  }
            var newdate = nwdate.setDate(nwdate.getDate() + 1);
            this.rreturn_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
          } 
          else {  this.rreturn_d_date = dep_date;  }
          start_date=dep_date+" "+dep_time;  end_date=this.return_d_date+" "+arr_time;
          return this.getDataDiff(new Date(start_date.toString()), new Date(end_date.toString()));
        }
        else{
          if(list.return_flight_data.next_day == 1){
            // console.log("duration not zero and nextday 1")
            if (!dep_date) {  nwdate = new Date();  } 
            else {  nwdate = new Date(dep_date);  }
            var newdate = nwdate.setDate(nwdate.getDate() + 1);
            this.rreturn_d_date = this.datePipe.transform(newdate, 'yyyy-MM-dd');
          }else{
            // console.log("duration not zero and nextday 0")
            // this.rreturn_d_date = list.return_flight_data.return_departure_date;
            return parseInt((list.return_flight_data.duration).split(':')[0])+' hr : '+parseInt((list.return_flight_data.duration).split(':')[1])+' mins';
          }
          return parseInt((list.return_flight_data.duration).split(':')[0])+' hr : '+parseInt((list.return_flight_data.duration).split(':')[1])+' mins';
      }
    }  
  
  }
  
  durationSplit(duration) {

    var split_duration = duration.split(':');
    return split_duration[0] + ' hrs : ' + split_duration[1] + ' mins'

  }

  getDataDiff(s_date, e_date) {
    var diff = e_date.getTime() - s_date.getTime();
    var days = Math.floor(diff / (60 * 60 * 24 * 1000));
    var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
    var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
    var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
    return hours + " hrs " + ": " + minutes + " min";
    // return { day: days, hour: hours, minute: minutes, second: seconds };
  }



  checkOffer(){
  // checkOffer(list,type){
    $('#totalpassengers').modal('show');
    // console.log("offerList Data",list);
    // this.offerList=list;
    // sessionStorage.setItem("offerDetail", JSON.stringify(this.offerList));
    // sessionStorage.setItem("offerType", JSON.stringify(type));
  }

  setAdult(val){
    this.adult=val;
  }  
  setChild(val){
    this.child=val;
  }  
  setInfant(val){
    this.infant=val;
  }  
  setTraveller(){
    this.travellerDetail = (this.adult + this.child + this.infant)
    // console.log("total value of traveller",this.travellerDetail);
    this.travellerShow = false;
  }
  
   traveller() {
    // var adult = this.travellers.value.adult;
    // var child = this.travellers.value.child;
    // var infant = this.travellers.value.infant;
    // if (this.adult != '' && this.child != '' && this.infant != '') {
  
      if (this.adult >= this.infant) {
        this.total = Number(this.adult) + Number(this.child) + Number(this.infant);
        var data={
          adult:Number(this.adult),
          child:Number(this.child),
          infant:Number(this.infant),
          total:this.total
        }
        this.travDetl = data;
        console.log("total :::::",this.total)
        $('#totalpassengers').modal('hide');
        this.searchForm.patchValue({ travellers: this.total });
        var requestdata=JSON.parse(sessionStorage.getItem("search_form_Data"));
        requestdata.infant=data.infant
        requestdata.children=data.child
        requestdata.child=data.child
        requestdata.adult=data.adult
        sessionStorage.setItem("travlerDetail", JSON.stringify(data));
        sessionStorage.setItem("search_form_Data", JSON.stringify(requestdata));

        // this.router.navigateByUrl("/offer-view");
        } else {
        alert('Please select infant less than adult');
      }    
    // }else{
    //   alert('Please select 1 adult');
    // }
  }

  contactSupport() {
    $('#offlineModle').modal('show');
  }

  set_d_date(val) {
    this.searchForm.patchValue({ return_date:this.formdata.return_date?this.formdata.return_date:'' });
    this.isSelectedDate=this.datePipe.transform(val, 'yyyy-MM-dd');
    this.currentDateStep = this.d_date.findIndex(e => e.flight_date == this.isSelectedDate);
    var currentdate = this.datePipe.transform(val, 'yyyy-MM-dd');
    this.searchForm.patchValue({ departure_date: this.datePipe.transform(val, 'yyyy-MM-dd') });
    if (this.flighttype == 'return') {
      var sendrequestdata = {       
        departure_city_code: this.searchForm.value.departure_city_code, 
        arrival_city_code: this.searchForm.value.arrival_city_code,
        departure_city_id:Number(this.searchForm.value.departure_city_id),  
        arrival_city_id:Number(this.searchForm.value.arrival_city_id),
        departure_date:this.datePipe.transform(val, 'yyyy-MM-dd'),
        is_return: 1,
      }
      var validdates = []
      this.sharedService.post('v1/common_new/return_dates', sendrequestdata).subscribe((res) => {
        this.sharedService.loadingShow = false;
        if (res.replyCode == "success") {
          res.data.forEach(element => {
            // var nwdate = new Date(currentdate);
            // var newdate = nwdate.setDate(nwdate.getDate() + element.return_in_days);
            var return_d_date = this.datePipe.transform(element.flight_date, 'MM/dd/yyyy');
            validdates.push(new Date(return_d_date))
          });
          var date_length = validdates.length;
          if (date_length > 0) {
            this.return_min_date = this.datePipe.transform(validdates[0], 'yyyy-MM-dd');
            this.return_max_date = this.datePipe.transform(validdates[date_length - 1], 'yyyy-MM-dd');
          }
          this.myFilter = (d: Date): boolean => {  const time = d.getTime();  return validdates.find(x => x.getTime() == time);  }
        }
      });
    }


    // var nwdate =  new Date(newReturnTodate);
    // var newdate= nwdate.setDate(nwdate.getDate()+this.ReturnfirstFormGroup.value.trip_duration);
    // var return_d_date=this.datePipe.transform(newdate, 'yyyy-MM-dd');
  }



  changestatus(label) {
    if (label == 'arrivaldate_input') {
      this.submitted = false;
      this.searchForm.patchValue({ departure_city_id: '', departure_date: '', return_date: '' });
      this.arrivaldate_input = true
    } else if (label == 'departure_date') {
      this.submitted = false;
      this.searchForm.patchValue({ departure_date: '', return_date: '' });
      this.departure_date = true
    } else if (label == 'return_date_input') {
      this.submitted = false;

      //console.log("return date")
      this.return_date_input = true
    } else if (label == 'traveller_input') {
      this.submitted = false;
      this.traveller_input = true
    }
  }
  set_r_date(val) {
    //console.log("return date",this.datePipe.transform(val, 'yyyy/MM/dd'));
    this.searchForm.patchValue({ return_date: this.datePipe.transform(val, 'yyyy-MM-dd') });
  }
  initiate() {
    // this.searchForm = this.fb.group({
    //   departure_city_id: ['', [Validators.required]],
    //   departure_city_code:['',[Validators.required]],
    //   departure_airport_id: ['', [Validators.required]],
    //   arrival_city_id: ['', [Validators.required]],
    //   arrival_city_code:['',[Validators.required]],
    //   arrival_airport_id: ['', [Validators.required]],
    //   trip_type: ['0', [Validators.required]],
    //   departure_date: ['', [Validators.required]],
    //   return_date: [''],
    //   adult: 1,
    //   child: 0,
    //   travellers: '1',
    //   infant: 0
    // });
    // this.travellers = this.fb.group({
    //   adult: ['1'],
    //   child: ['0'],
    //   infant: ['0'],
    // });
    $('mat-select-search-input').attr('placeholder', 'departure city')
  }
  Change_Status(val) {
    this.selectFlightType = val
    console.log("change Status:::::::::",this.selectFlightType);
    this.initiate()
    if (val == 'oneway') {
      this.disableInput = true;
      this.return_date = '';
      this.flighttype = 'oneway';
      this.searchForm.patchValue({
        trip_type: '0',
        adult: 1,
        child: 0,
        travellers: 1,
        infant: 0
      });
      this.return_date_input = false;
      this.departure_city_list();
    } else {
      this.flighttype = 'return';
      this.disableInput = null;
      this.searchForm.patchValue({
        trip_type: '1',
        adult: 1,
        child: 0,
        travellers: 1,
        infant: 0
      });
      this.departure_city_list();
    }

    //console.log("flight type",this.searchForm.value);
  }
  public templateResult = (state: Select2OptionData): JQuery | string => {
    if (!state.id) { return state.text; }
    return jQuery('<span style="font-weight:500">' + state.text + ' </span><p style="margin:0px;font-size:10px;position:relative"><span style="font-size:12px;float:right;right:3px;margin-top:-20px;font-weight:500;position:absolute;">' + state.additional.image + '</span></p>');
    // return jQuery('<span style="font-weight:500">' + state.text + ' </span><p style="margin:0px;font-size:10px;position:relative"><span style="font-size:12px;float:right;right:3px;margin-top:-20px;font-weight:500;position:absolute;">' + state.additional.image + '</span></p>');
  }
  public templateSelection = (state: Select2OptionData): JQuery | string => {
    if (!state.id) { return state.text; }
    return jQuery('<span>' + state.text + '&nbsp; (' + state.additional.image + ')</span>');
  }
  departure_city_list() {
    this.flightdetails = null; const self = this;
    this.departure_city_data = []; this.d_city = [];
    this.ngxLoader.start();
    self.sharedService.loadingShow = true;
    var sendrequestdata = {
      // flight_type: 'one_way'
      flight_type: (this.flighttype == 'oneway' || this.flighttype == 'one_way' ? 'one_way' : 'return')
    }
    self.sharedService.loadingShow = false;
    this.sharedService.post('v1/common_new/dep_city', sendrequestdata).subscribe((res) => {
      self.sharedService.loadingShow = false;
      if (res.replyCode == "success") {
        if ((res.data).length != 0) {
          this.departurePartnerList = res.data;
          self.departurePartnerList.forEach(element => {
            var newdata = this.d_city.find(ele => ele.depcode == element.departure_city_code);
            if (newdata == undefined) {
              self.d_city.push({
                id: element.departure_city_id,
                text: element.departure_city_name + ' <span style="display:none;">' + element.departure_city_code + '</span>',
                // text: element.departure_city_name ,
                depcode: element.departure_city_code,
                searchtype: 'partner',
                additional: {
                  image: element.airport_code,
                  winner: element.airport_name,
                  airportId: element.airport_id
                }
              })
            } else {
              var index = this.d_city.findIndex(ele => { return (ele.depcode == element.departure_city_code) })
              this.d_city[index].searchtype = 'both';
            }
          });
        }
        this.d_city.sort((a, b) => a.text.localeCompare(b.text)); 
        this.departure_city_data = this.d_city;
        this.ngxLoader.stop();
      }
      this.options = { templateResult: this.templateResult, templateSelection: this.templateSelection };
    }, err => {
      this.departure_city_data = this.d_city;
      this.options = { templateResult: this.templateResult, templateSelection: this.templateSelection }; 
      this.ngxLoader.stop();
      this.toastr.errorToastr(err.error.message, "Error")
    });
  }
  arrival_city_list(id) {
    this.arrivalPartnerList=[]
    if (id) {
      const self = this;
      self.sharedService.loadingShow = true;
      this.ngxLoader.start();

        var datalist = this.departurePartnerList.filter(x => x.departure_city_id == id);
        this.searchForm.patchValue({ 
          departure_city_id: id, 
          departure_city_code: datalist[0].departure_city_code, 
          departure_airport_id: datalist[0].departure_airport_id 
        })
        self.sharedService.loadingShow = true;
        var sendrequestdata1 = {
          departure_city_code: datalist[0].departure_city_code,
          departure_city_id: datalist[0].departure_city_id,
          flight_type: (this.flighttype == 'oneway' || this.flighttype == 'one_way' ? 'one_way' : 'return')
        }

        this.a_city = [];
        this.sharedService.post('v1/common_new/arr_city', sendrequestdata1).subscribe((res) => {
          self.sharedService.loadingShow = false;
          if (res.replyCode == "success" || res.replyCode == "error") { this.ngxLoader.stop(); }
          if (res.replyCode == "success") {
            self.arrivalPartnerList = res.data;
            this.Arrivalcity_DATA.length = 0;
            self.arrivalPartnerList.forEach(element => {
              this.a_city.push({
                id: element.arrival_city_id,
                text: element.arrival_city_name + ' <span style="display:none;">' + element.arrival_city_code + '</span>',
                depcode: element.arrival_city_code,
                additional: {
                  image: element.airport_code,
                  winner: element.airport_name,
                  airportId: element.arrival_airport_id
                }
              })
            });
            // this.a_city.sort((a, b) => a.text.localeCompare(b.text)); this.arrival_city_data = this.a_city;
            this.arrival_city_data= this.a_city.filter((item, i, ar) => ar.indexOf(item) === i).sort((a,b) => a.text.localeCompare(b.text));
            this.options1 = { templateResult: this.templateResult, templateSelection: this.templateSelection };
          }
        });
    }
  }
  departure_date_list(val) {
    if (this.myFilter1) { this.myFilter1 = !this.myFilter1; }
      this.searchForm.patchValue({ return_date: this.formdata.return_date?this.formdata.return_date:'' });
      this.searchForm.patchValue({ departure_date: this.formdata.departure_date?this.formdata.departure_date:'' })
    console.log('this.sectorDataArrya =============================== 969 ===', this.arrivalPartnerList);

    if (val) {
      this.ngxLoader.start();
      this.filterlist = this.arrivalPartnerList.filter(x => x.arrival_city_id == val);
      this.departure_city_ids=this.filterlist[0].depCityId;  this.arrival_city_ids = this.filterlist[0].arrCityId;
      const self = this; self.sharedService.loadingShow = true; var is_rtn;
      this.searchForm.patchValue({ 
       arrival_city_id:this.filterlist[0].arrival_city_id ,
        arrival_city_code:this.filterlist[0].arrival_city_code,  
        arrival_airport_id:this.filterlist[0].arrival_airport_id  
      })
      if (this.flighttype == 'return') { is_rtn = 1; } else { is_rtn = 0; }
        var formData = this.searchForm.value;
      var sendrequestdata = {
        departure_city_code: formData.departure_city_code,
        departure_city_id: formData.departure_city_id,
        arrival_city_id:this.filterlist[0].arrival_city_id ,
        arrival_city_code:this.filterlist[0].arrival_city_code,
        is_return: is_rtn
      }
      var validdates = [];
      this.sharedService.post('v1/common_new/dates', sendrequestdata).subscribe((res) => {
        self.sharedService.loadingShow = false;
        if (res.replyCode == "success" || (res.data).length != 0) {
          if (res.length != 0) {
            sessionStorage.setItem("availabledates",JSON.stringify(this.d_date));    
            this.disableDate = false;
            self.d_date = res.data;
            var date_length = res.data.length;
            this.departure_Date_start = self.d_date[0].flight_date;
            this.departure_Date_end = self.d_date[this.d_date.length - 1].flight_date;
            sessionStorage.setItem("availabledates",JSON.stringify(this.d_date));   
            this.commonService.SetDateArray(this.d_date);  
            if (date_length == 1) {
              validdates.push(new Date(this.datePipe.transform(self.d_date[0].flight_date, 'MM/dd/yyyy')))
            } else if (date_length > 1) {
              res.data.forEach(element => { validdates.push(new Date(this.datePipe.transform(element.flight_date, 'MM/dd/yyyy'))) });
            }
            if (this.d_date) {
              this.minDate = self.d_date[0].flight_date; this.maxDate = self.d_date[date_length - 1].flight_date
            }
            this.date = new Date((new Date(this.minDate).getTime()));
            setTimeout(() => {
              validdates.sort((a, b) => { return <any>new Date(a) - <any>new Date(b); });
              this.d_date.sort((a, b) => { return <any>new Date(a.flight_date) - <any>new Date(b.flight_date); });
              this.myFilter1 = (d: Date): boolean => { const time = d.getTime(); return validdates.find(x => x.getTime() == time); }
              this.ngxLoader.stop();
            }, 700);
          } else { validdates = []; }
        }
        if (res.replyCode == "success" || res.replyCode == "error") { this.ngxLoader.stop(); }
      });

    }
  }
  ngAfterViewInit() {
    this.setInitialValue();
  }
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();

    this._onDestroy1.next();
    this._onDestroy1.complete();
  }
  protected setInitialValue() {
    this.filtered_departurecity
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.departureSelect.compareWith = (a: departurecity_lists, b: departurecity_lists) => a && b && a.id === b.id;
      });
  }
  protected filterDeparturecity() {
    if (!this.Departurecity_DATA) {
      return;
    }
    // get the search keyword
    let search = this.departureFilterCtrl.value;
    if (!search) {
      this.filtered_departurecity.next(this.Departurecity_DATA.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtered_departurecity.next(
      this.Departurecity_DATA.filter(a => a.departure_city_name.toLowerCase().indexOf(search) > -1)
    );

  }
  protected filterarrivalcity() {
    if (!this.Arrivalcity_DATA) {
      return;
    }
    // get the search keyword
    let search = this.arrivalFilterCtrl.value;
    if (!search) {
      this.filtered_arrivalcity.next(this.Arrivalcity_DATA.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtered_arrivalcity.next(
      this.Arrivalcity_DATA.filter(d_city => d_city.arrival_city_name.toLowerCase().indexOf(search) > -1)
    );
  }
  dateTransform(date){
    var dates = new Date(date);
    return this.datePipe.transform(dates, "dd-MM-yyyy")
  }

}

export interface JQuery {
}

export interface arrivalcity_lists {
  id: number;
  arrival_city_id: number;
  arrival_city_name: string;
  arrival_city_code: number;
  airport_name: string;
  airport_id: number;
}
export interface departurecity_lists {
  id: number;
  departure_city_id: number;
  departure_city_name: string;
  departure_city_code: number;
  airport_name: string;
  airport_id: number;

}
